module.exports = __webpack_public_path__ + "img/pen-to-square-solid.18cdca6b.svg";